import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { BannerStatus } from './banner-status.interface';
import { defaultTranslations, Translations } from '../translations';

@Component({
  selector: 'zelis-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @HostBinding() class = 'zelis-dls';
  @HostBinding('class.hidden') isClosed = false;

  @Input() public status: BannerStatus = 'info';
  @Input() public showIcon = true;
  @Input() public clamp = true;
  @Input() public container = false;
  @Input() public expanded = false;
  @Input() public dismissible = false;
  @Input() public showMoreText = 'Show More';
  @Input() public showLessText = 'Show Less';
  @Input() public translations: Translations = defaultTranslations;
  @Input() public systemBlue = false;

  @Output() public closed: EventEmitter<void> = new EventEmitter();

  public onClose(): void {
    this.isClosed = true;
    this.closed.emit();
  }
}
